(function () {
  function pad2(n) {
    return String(n).padStart(2, "0");
  }

  function secondsToMidnightInZone(timeZone) {
    var now = new Date();
    var parts = new Intl.DateTimeFormat("en", {
      timeZone: timeZone,
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hourCycle: "h23",
    }).formatToParts(now);
    var hour = 0;
    var minute = 0;
    var second = 0;
    for (var i = 0; i < parts.length; i++) {
      var p = parts[i];
      if (p.type === "hour") hour = parseInt(p.value, 10) || 0;
      if (p.type === "minute") minute = parseInt(p.value, 10) || 0;
      if (p.type === "second") second = parseInt(p.value, 10) || 0;
    }
    var elapsed = hour * 3600 + minute * 60 + second;
    return 86400 - elapsed;
  }

  function tick(el) {
    var tz = el.getAttribute("data-timezone") || "America/New_York";
    var sec = secondsToMidnightInZone(tz);
    var d = Math.floor(sec / 86400);
    sec %= 86400;
    var h = Math.floor(sec / 3600);
    var m = Math.floor((sec % 3600) / 60);
    var s = sec % 60;
    var dEl = el.querySelector("[data-ac-days]");
    var hEl = el.querySelector("[data-ac-hours]");
    var mEl = el.querySelector("[data-ac-minutes]");
    var sEl = el.querySelector("[data-ac-seconds]");
    if (dEl) dEl.textContent = pad2(d);
    if (hEl) hEl.textContent = pad2(h);
    if (mEl) mEl.textContent = pad2(m);
    if (sEl) sEl.textContent = pad2(s);
  }

  function init(el) {
    if (el.dataset.acInit) return;
    el.dataset.acInit = "1";
    function run() {
      tick(el);
    }
    run();
    setInterval(run, 1000);
  }

  function initAll() {
    document.querySelectorAll("[data-announcement-countdown]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
})();
